import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";

export default function PortalProfile() {
  const [profile, setProfile] = useState(null);
  useEffect(() => { api.get("/clients/me/profile").then(r => setProfile(r.data)); }, []);
  if (!profile) return <DashboardLayout role="client"><div className="p-10 text-[#756E64]">Loading…</div></DashboardLayout>;
  return (
    <DashboardLayout role="client">
      <div className="max-w-[1000px] mx-auto px-8 py-10">
        <div className="as-overline">Preferences on file</div>
        <h1 className="as-serif text-5xl font-light mt-2" data-testid="profile-title">{profile.name}</h1>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Row label="Client Type" value={profile.client_type}/>
          <Row label="Email" value={profile.email}/>
          <Row label="Phone" value={profile.phone}/>
          <Row label="Address" value={profile.address}/>
          <Row label="Preferred Airports" value={profile.preferred_airports?.join(" · ")}/>
          <Row label="Preferred Hotels" value={profile.preferred_hotels?.join(" · ")}/>
          <Row label="Preferred Transport" value={profile.preferred_transport}/>
          <Row label="Food & Beverage" value={profile.food_preferences}/>
          <Row label="Security" value={profile.security_requirements}/>
          <Row label="Passport / Docs" value={profile.passport_notes}/>
          <Row label="Special notes" value={profile.special_notes} full/>
        </div>
        <div className="mt-8 text-xs text-[#756E64]">To update preferences, message your ops lead — we treat every change as a critical event.</div>
      </div>
    </DashboardLayout>
  );
}
function Row({ label, value, full }) {
  return (
    <div className={`as-card p-5 ${full ? "md:col-span-2" : ""}`}>
      <div className="as-mono text-[10px] uppercase tracking-widest text-[#756E64]">{label}</div>
      <div className="text-sm text-[#1A1D24] mt-2">{value || "—"}</div>
    </div>
  );
}
